import styled from 'styled-components'
import { Column } from 'components/common/layout'
import { DescText, SemiBoldText } from 'components/common/text'

export const Layout = styled(Column)`
  margin: 0 auto;
  @media ${(p) => p.theme.deviceSize.mobile} {
    max-width: 500px;
    padding: 20px;
    gap: 24px;
  }
  @media ${(p) => p.theme.deviceSize.desktop} {
    max-width: 1060px;
    padding: 48px 0;
    gap: 32px;
  }
`

export const Background = styled.div`
  padding: 60px 0;
  @media ${(p) => p.theme.deviceSize.mobile} {
    background-color: ${(p) => p.theme.color.background};
  }
`

export const MainText = styled(SemiBoldText)`
  line-height: 1.6;
  @media ${(p) => p.theme.deviceSize.desktop} {
    font-size: 44px;
    font-weight: ${(p) => p.theme.fontWeight.bold};
    text-align: center;
  }
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: ${(p) => p.theme.fontSize.h3};
  }
`

export const SubText = styled(DescText)`
  color: ${(p) => p.theme.color.black2};
  @media ${(p) => p.theme.deviceSize.desktop} {
    font-size: ${(p) => p.theme.fontSize.h5};
    white-space: nowrap;
    text-align: center;
  }
`
